export default __webpack_public_path__ + "static/media/a' cadal.63d3505c.mp3";